/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { SysqueGaugeComponent } from '../../components/workspace/sysque-gauge/sysque-gauge-component';
import { SysquePopupConfig } from '../../models/sysque-popup-config';
import { PopupDialog } from '../popup-dialog.interface';

export class SysQueGaugeDialog implements PopupDialog {
  create(sysquePopupConfig: SysquePopupConfig): any {
    sysquePopupConfig.component = SysqueGaugeComponent;
    sysquePopupConfig.height = 450;
    sysquePopupConfig.width = 290;
  }
}
